module.exports = __webpack_public_path__ + "static/media/train_otgruzka.f7e7037d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/train_otgruzka.jpg
// module id = 148
// module chunks = 0